import { AxiosProgressEvent } from "axios";
import { api } from "../libs/baseApi";
import {
  Vehicle,
  ApiListResponse,
  VehicleListParams,
  ApiResponse,
  VehiclePayload,
  ApiImportData,
} from "../types";

// Example of fetching vehicle data
export const getVehicleData: (
  params?: VehicleListParams
) => Promise<ApiListResponse<Vehicle>> = async (params) => {
  try {
    const response = await api.get("/vehicles", {
      params: {
        page: params?.page,
        limit: params?.limit,
        ...params?.filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle data:", error);
    throw error;
  }
};

// Example of fetching vehicle data by id
export const getVehicleDataById: (id: string) => Promise<Vehicle> = async (
  id
) => {
  try {
    const response = await api.get(`/vehicles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle data by id:", error);
    throw error;
  }
};

// Example of creating vehicle data
export const createVehicleData: (
  data: Partial<VehiclePayload>
) => Promise<ApiResponse<Vehicle>> = async (data) => {
  try {
    const response = await api.post("/vehicles", data);
    return response.data;
  } catch (error) {
    console.error("Error creating vehicle data:", error);
    throw error;
  }
};

// Example of updating vehicle data
export const updateVehicleData: (
  data: Partial<VehiclePayload>
) => Promise<ApiResponse<Vehicle>> = async (data) => {
  try {
    const response = await api.put(`/vehicles/${data.ulid}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating vehicle data:", error);
    throw error;
  }
};

// Example of deleting vehicle data
export const deleteVehicleData: (
  id: string
) => Promise<ApiResponse<Vehicle>> = async (id) => {
  try {
    const response = await api.delete(`/vehicles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting vehicle data:", error);
    throw error;
  }
};

export const exportVehicleData: (
  params?: VehicleListParams
) => Promise<{ data: any; filename: string }> = async (params) => {
  let filename;
  try {
    const response = await api.get("/vehicles/export", {
      params: {
        ...params?.filters,
      },
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
      const filenameMatch = contentDisposition.split("filename=")[1];
      if (filenameMatch) {
        filename = filenameMatch;
      }
    }

    return {
      data: response.data,
      filename,
    };
  } catch (error) {
    console.error("Error exporting vehicle data:", error);
    throw error;
  }
};

export const importVehicleData: ({
  data,
  progressCallback,
}: {
  data: FormData;
  progressCallback: (progressEvent: AxiosProgressEvent) => void;
}) => Promise<ApiResponse<ApiImportData>> = async ({
  data,
  progressCallback,
}) => {
  try {
    const response = await api.post("/vehicles/import", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: progressCallback,
    });
    return response.data;
  } catch (error) {
    console.error("Error importing vehicle data:", error);
    throw error;
  }
};
